// import { Modal } from "antd";
// import { InputOTP } from "antd-input-otp";
// import React, { useState } from "react";
// import styled from "styled-components";
// import { AuthArrow, CongratsIcon } from "../utils/Images";
// import { register, verifyotp } from "../collection/ApiCollection";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";

// const RegisterSteps = ({
//   openRegisterStepsModal,
//   handleCancelRegisterStepsModal,
//   inputValue,
//   countryCode,
//   checkType,
//   modalData,
// }) => {
//   const [type, setType] = useState(null);
//   const [loader, setLoader] = useState(false);
//   const navigate = useNavigate();
//   const [otp, setOtp] = useState(""); // Store OTP as a string

//   console.log(otp, "otp");

//   const handleSendOtp = async (value) => {
//     if (otp.length < 4) {
//       toast.error("Please enter the required OTP");
//       return;
//     }
//     setLoader(true);
//     let reqForEmail = {
//       email: inputValue,
//       otp: otp, // Send correct OTP value
//       type: "email",
//     };
//     let reqForNum = {
//       phoneNumber: inputValue,
//       countryCode: countryCode,
//       otp: otp, // Send correct OTP value
//       type: "sms",
//     };

//     try {
//       let res = await verifyotp(checkType ? reqForNum : reqForEmail);
//       if (res.status === 200) {
//         let reqForEmail = {
//           email: inputValue,
//           fullName: modalData?.fullName,
//           password: modalData?.password,
//           confirmPassword: modalData?.confirmPassword,
//         };
//         let reqForNum = {
//           countryCode: countryCode,
//           phoneNumber: inputValue,
//           fullName: modalData?.fullName,
//           password: modalData?.password,
//           confirmPassword: modalData?.confirmPassword,
//         };
//         let res = await register(checkType ? reqForNum : reqForEmail);
//         try {
//           if (res.status === 200) {
//             toast.success(res?.data?.message);
//             setType(value);
//           } else {
//             toast.error(res?.response?.data?.message || "Something went wrong");
//           }
//         } catch (error) {
//           toast.error(error?.response?.data?.message || "Something went wrong");
//         }
//       } else {
//         toast.error("Verification failed");
//       }
//     } catch (error) {
//       toast.error(
//         error?.response?.data?.message ||
//         error?.error ||
//         error?.message ||
//         "Something went wrong"
//       )
//     } finally {
//       setLoader(false);
//     }
//   };

//   const handleOtpChange = (value) => {
//     setOtp(value.map((digit) => digit || "").join("")); // Convert array to string safely
//   };

//   return (
//     <Modal
//       centered
//       footer={false}
//       open={openRegisterStepsModal}
//       onOk={handleCancelRegisterStepsModal}
//       onCancel={handleCancelRegisterStepsModal}
//     >
//       <RegisterStepsWrapper>
//         {type !== "verifyOtp" ? (
//           <div className="verification-div">
//             <h1 className="main-heading">Enter Verification Code</h1>
//             <div className="otp-input">
//               <InputOTP
//                 length={4}
//                 inputType="numeric"
//                 value={otp.split("")}
//                 onChange={handleOtpChange}
//               />
//             </div>
//             <div className="otp-time">
//               <p>
//                 Didn’t get OTP code? <span>Resend</span>
//               </p>
//               <p style={{ color: "#0DA982" }}>01:59</p>
//             </div>
//             <div className="btn-div">
//               <button onClick={() => handleSendOtp("verifyOtp")}>
//                 {loader ? "Loading..." : "VERIFY OTP"}
//               </button>
//             </div>
//           </div>
//         ) : (
//           <div className="congratulation-div">
//             <h1 className="congratts-heading">Congratulations</h1>
//             <p className="congratts-para">Your account has been created</p>
//             <div className="congrats-img-div">
//               <img src={CongratsIcon} alt="" className="congratts-img" />
//             </div>
//             <div className="signin-method">
//               <button onClick={() => navigate("/")}>
//                 START <img src={AuthArrow} alt="" />
//               </button>
//             </div>
//           </div>
//         )}
//       </RegisterStepsWrapper>
//     </Modal>
//   );
// };

// export default RegisterSteps;





import { Modal } from "antd";
import { InputOTP } from "antd-input-otp";
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { AuthArrow, CongratsIcon } from "../utils/Images";
import { register, sendotp, verifyotp } from "../collection/ApiCollection";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { authlogin, authtemplogin } from "../store/Authentication";

const RegisterSteps = ({
  openRegisterStepsModal,
  handleCancelRegisterStepsModal,
  inputValue,
  countryCode,
  checkType,
  modalData,
}) => {
  const dispatch = useDispatch()
  const [type, setType] = useState(null);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(120);
  const [canResend, setCanResend] = useState(false);
  const registeredData = useSelector((state) => state?.Authlogin?.dataTemp);
  console.log(registeredData, "registeredData")

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else {
      setCanResend(true);
    }
  }, [timer]);

  const handleSendOtp = async (value) => {
    if (otp.length < 4) {
      toast.error("Please enter the required OTP");
      return;
    }
    setLoader(true);
    let reqForEmail = {
      email: inputValue,
      otp: otp,
      type: "email",
    };
    let reqForNum = {
      phoneNumber: inputValue,
      countryCode: countryCode,
      otp: otp,
      type: "sms",
    };

    try {
      let res = await verifyotp(checkType ? reqForNum : reqForEmail);
      if (res.status === 200) {
        let reqForEmail = {
          email: inputValue,
          fullName: modalData?.fullName,
          password: modalData?.password,
          confirmPassword: modalData?.confirmPassword,
        };
        let reqForNum = {
          countryCode: countryCode,
          phoneNumber: inputValue,
          fullName: modalData?.fullName,
          password: modalData?.password,
          confirmPassword: modalData?.confirmPassword,
        };
        let res = await register(checkType ? reqForNum : reqForEmail);
        if (res.status === 200) {
          toast.success(res?.data?.message);
          setType(value);
          dispatch(authtemplogin(res?.data?.data))
        } else {
          toast.error(res?.response?.data?.message || "Something went wrong");
        }
      } else {
        toast.error("Verification failed");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        error?.error ||
        error?.message ||
        "Something went wrong"
      );
    } finally {
      setLoader(false);
    }
  };

  const handleResendOtp = async () => {
    setCanResend(false);
    setTimer(120);
    try {
      let reqForEmail = { email: inputValue, type: "email" };
      let reqForNum = { phoneNumber: inputValue, countryCode: countryCode, type: "sms" };
      await sendotp(checkType ? reqForNum : reqForEmail);
      toast.success("OTP has been resent successfully");
    } catch (error) {
      toast.error("Failed to resend OTP");
    }
  };

  const handleOtpChange = (value) => {
    setOtp(value.map((digit) => digit || "").join(""));
  };

  return (
    <Modal
      centered
      footer={false}
      open={openRegisterStepsModal}
      onOk={handleCancelRegisterStepsModal}
      onCancel={handleCancelRegisterStepsModal}
    >
      <RegisterStepsWrapper>
        {type !== "verifyOtp" ? (
          <div className="verification-div">
            <h1 className="main-heading">Enter Verification Code</h1>
            <div className="otp-input">
              <InputOTP length={4} inputType="numeric" value={otp.split("")} onChange={handleOtpChange} />
            </div>
            <div className="otp-time" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "78%" }}>
              <p>
                Didn’t get OTP? {!canResend ? <span style={{ cursor: "pointer", color: "gray" }}>Resend</span> : <span onClick={handleResendOtp} style={{ cursor: "pointer" }}>Resend</span>}
              </p>
              <p>{!canResend && (
                <span style={{ color: "#0DA982" }}>{Math.floor(timer / 60)}:{(timer % 60).toString().padStart(2, "0")}</span>
              )}</p>
              {/* (
                <span onClick={handleResendOtp} style={{ cursor: "pointer" }}>Resend</span>
              ) : */}
            </div>
            <div className="btn-div">
              <button onClick={() => handleSendOtp("verifyOtp")}>
                {loader ? "Loading..." : "VERIFY OTP"}
              </button>
            </div>
          </div>
        ) : (
          <div className="congratulation-div">
            <h1 className="congratts-heading">Congratulations</h1>
            <p className="congratts-para">Your account has been created</p>
            <div className="congrats-img-div">
              <img src={CongratsIcon} alt="" className="congratts-img" />
            </div>
            <div className="signin-method">
              <button onClick={() => dispatch(authlogin(registeredData))}>
                START <img src={AuthArrow} alt="" />
              </button>
            </div>
          </div>
        )}
      </RegisterStepsWrapper>
    </Modal>
  );
};

export default RegisterSteps;


const RegisterStepsWrapper = styled.div`
  padding-bottom: 40px;
  .verification-div {
    .main-heading {
      font-size: 23px;
      font-weight: 700;
      margin-top: 40px;
      text-align: center;
      margin-bottom: 52px;
    }
    .otp-input {
      margin-bottom: 52px;
    }
    .otp-time {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 78%;
      margin: auto;
      p {
        font-size: 15px;
        color: #64748b;
        span {
          font-weight: 700;
          color: #0da982;
        }
      }
    }
    .btn-div {
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        height: 48px;
        background: #0da982;
        color: #fff;
        font-size: 16px;
        font-weight: 700;
        border: none;
        max-width: 225px;
        width: 100%;
        border-radius: 15px;
        margin-top: 46px;
        cursor: pointer;
      }
    }
  }
  .congratulation-div {
    .congratts-heading {
      font-size: 23px;
      font-weight: 700;
      text-align: center;
      margin-top: 40px;
    }
    .congratts-para {
      font-size: 23px;
      font-weight: 400;
      margin-top: 26px;
      margin-bottom: 56px;
      text-align: center;
    }
    .congrats-img-div {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 51px;
      .congratts-img {
        width: 132px;
        height: 132px;
      }
    }
    .signin-method {
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        color: #fff;
        font-size: 16px;
        font-weight: 400;
        background: #0da982;
        height: 48px;
        padding: 0px 30px;
        position: relative;
        border: none;
        border-radius: 15px;
        display: flex;
        align-items: center;
        max-width: 225px;
        width: 100%;
        justify-content: center;
        cursor: pointer;
        img {
          position: absolute;
          width: 24px;
          height: 24px;
          right: 10px;
        }
      }
    }
  }
`;